<aside class="fixed top-0 left-0 z-40 w-64 h-screen transition-transform sm:translate-x-0" aria-label="Sidebar">
  <div class="h-full px-3 py-4 overflow-y-auto bg-gray-50 flex flex-col">
    <div class="mb-5 px-2">
      <h2 class="text-xl font-semibold text-gray-900">Menú</h2>
    </div>

    <ul class="space-y-2 font-medium flex-1">
      @for (item of menuItems; track item.route) {
      <li>
        @if (item.onlyAdmin && !userAdmin || item.route === '/chatbot-test' && !userChatbot) {
          <div class="flex items-center p-2 text-gray-400 rounded-lg cursor-not-allowed opacity-50">
            <span class="text-xl text-gray-400">{{ item.icon }}</span>
            <span class="ms-3">{{ item.label }}</span>
          </div>
        } @else {
          <a [routerLink]="item.route" routerLinkActive="bg-gray-700 text-white hover:bg-gray-800"
            [routerLinkActiveOptions]="{exact: false}"
            class="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-200 group transition-colors duration-200">
            <span class="text-xl text-gray-500 transition duration-75 group-hover:text-gray-900">{{ item.icon }}</span>
            <span class="ms-3">{{ item.label }}</span>
          </a>
        }
      </li>
      }
    </ul>

    <div class="mt-auto pt-4">
      <button (click)="onLogout()"
        class="flex items-center w-full p-2 text-gray-900 rounded-lg hover:bg-gray-200 group cursor-pointer">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="w-5 h-5 text-gray-900">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15m-3 0-3-3m0 0 3-3m-3 3H15" />
        </svg>
        <span class="ms-3">Cerrar sesión</span>
      </button>
    </div>
  </div>
</aside>